###
  Permission total popup
###

class INTENT.widgets.PermissionTotal

  @ATTR_NAME: "data-widget-permission-total"

  xhr: null

  constructor: (@el) ->
    @s = @.constructor

    $(document).on 'click', '[data-permission-total-show-user]', (e) =>
      e.preventDefault()
      self = $(e.currentTarget)
      target = self.data 'permission-total-show-user'
      title = self.data 'permission-total-title'
      @show_total_permissions target, 'user', title

    $(document).on 'click', '[data-permission-total-show-role]', (e) =>
      e.preventDefault()
      self = $(e.currentTarget)
      target = self.data 'permission-total-show-role'
      title = self.data 'permission-total-title'
      @show_total_permissions target, 'role', title

    $(document).on 'click', '[data-permission-total-show-form]', (e) =>
      e.preventDefault()
      self = $(e.currentTarget)
      target = self.data 'permission-total-show-form'
      title = self.data 'permission-total-title'
      @show_total_permissions target, 'form', title

    @el.on 'hidden.bs.modal', (e) =>
      #cancel ajax request if modal window closed by user
      @xhr.abort() if @xhr

  show_total_permissions: (target, source, title = '') ->
    data = {};

    if source in ['user', 'role']
      data[source] = +target
    else if source == 'form'
      form = $(target)
      if form && form.length
        formObject = do form.serializeObject
        data['form'] =
          roles: formObject.roles
          permissions: formObject.permissions

    if not (data.user or data.role or data.form)
      return false

    @xhr = $.ajax('/ajax/get_user_permissions_rendered', {
      type: 'POST',
      data: data,
      dataType: 'html',
      beforeSend: () =>
        @set_modal_title __('admin.permissions.total.title', {':object': title})
        @set_modal_content @get_loader_template()
        do @show_modal
      error: () =>
        do @close_modal
      success: (data) =>
        if (data)
          @set_modal_content data
        else
          do @close_modal
    })

  set_modal_title: (title) ->
    @el.find('[data-total-permissions-modal-title]').html(title);

  set_modal_content: (html) ->
    html = $(html).hide()
    @el.find('[data-total-permissions-modal-body]').html(html);
    html.fadeIn 'medium'

  show_modal: () ->
    @el.modal 'show'

  close_modal: () ->
    @el.modal 'hide'

  get_loader_template: () ->
    """
    <div class="text-center"><i class="fa fa-circle-o-notch fa-spin green fa-5x"></i></div>
    """